export class PasswordPolicy {
            
    public minLength:number
    public nbMinNumberChar:number
    public nbMinSpecialChar:number
    public nbMinUpperChar:number
    public nbMinLowerChar:number
    public validityPeriod:number
    public expireMessagePeriod:number
    public nbHistoryRetention:number
    public denyAccessIfPassHasExpired:boolean
    public denyAccessIfPassHasNoDate:boolean
    public disablePasswordPolicy:boolean

    constructor({minLength=12, nbMinNumberChar=1,nbMinSpecialChar=1,nbMinUpperChar=1,nbMinLowerChar=1,validityPeriod=180,expireMessagePeriod=12,nbHistoryRetention=0,denyAccessIfPassHasExpired=true,denyAccessIfPassHasNoDate=false,disablePasswordPolicy=false} = {}) {                                
        this.minLength = minLength
        this.nbMinNumberChar = nbMinNumberChar
        this.nbMinSpecialChar = nbMinSpecialChar
        this.nbMinUpperChar = nbMinUpperChar
        this.nbMinLowerChar = nbMinLowerChar
        this.validityPeriod = validityPeriod
        this.expireMessagePeriod = expireMessagePeriod
        this.nbHistoryRetention = nbHistoryRetention
        this.denyAccessIfPassHasExpired = denyAccessIfPassHasExpired
        this.denyAccessIfPassHasNoDate = denyAccessIfPassHasNoDate
        this.disablePasswordPolicy = disablePasswordPolicy
    }    

    static createPasswordPolicy(datas:string) {      
        let data = {}
        try{
            if(!datas) datas = ""
            data = JSON.parse(datas)
        }
        catch(e) {            
        }
        return new PasswordPolicy(data)
    }    

}
